<div class="">
  <form [formGroup]="form" [formEditablePermission]="form" [class.loading-section]="isSavingCustom$ | async">
    <div class="d-grid gap-3" style="grid-template-columns: auto">
      <div class="card p-3">
        <h6 class="text-uppercase" i18n>Custom Information 1</h6>
        <mat-form-field2 class="mat-block">
          <textarea
            matInput
            formControlName="custom1"
            i18n-placeholder
            placeholder="Enter Custom Information"
            rows="4"
            cdkTextareaAutosize
            cdkAutosizeMaxRows="8"
          ></textarea>
        </mat-form-field2>
      </div>
      <div class="card p-3">
        <h6 class="text-uppercase" i18n>Custom Information 2</h6>
        <mat-form-field2 class="mat-block">
          <textarea
            matInput
            formControlName="custom2"
            i18n-placeholder
            placeholder="Enter Custom Information"
            rows="4"
            cdkTextareaAutosize
            cdkAutosizeMaxRows="8"
          ></textarea>
        </mat-form-field2>
      </div>
      <div class="card p-3">
        <h6 class="text-uppercase" i18n>Custom Information 3</h6>
        <mat-form-field2 class="mat-block">
          <textarea
            matInput
            formControlName="custom3"
            i18n-placeholder
            placeholder="Enter Custom Information"
            rows="4"
            cdkTextareaAutosize
            cdkAutosizeMaxRows="8"
          ></textarea>
        </mat-form-field2>
      </div>

      <div class="card p-3">
        <h6 class="text-uppercase" i18n>Custom Information 4</h6>
        <mat-form-field2 class="mat-block">
          <textarea
            matInput
            formControlName="custom4"
            placeholder="Enter Custom Information"
            rows="4"
            cdkTextareaAutosize
            i18n-placeholder
            cdkAutosizeMaxRows="8"
          ></textarea>
        </mat-form-field2>
      </div>

      <div class="card p-3">
        <h6 class="text-uppercase" i18n>Custom Information 5</h6>
        <mat-form-field2 class="mat-block">
          <textarea
            matInput
            formControlName="custom5"
            placeholder="Enter Custom Information"
            rows="4"
            cdkTextareaAutosize
            i18n-placeholder
            cdkAutosizeMaxRows="8"
          ></textarea>
        </mat-form-field2>
      </div>
    </div>
  </form>
</div>
